//
// FillAttributes.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AttributesModel";
import "@sas-dvr/ltjs-commons/styles/ImageFitStyle";
import "@sas-dvr/ltjs-commons/styles/ImageFillType";
import "@sas-dvr/ltjs-commons/models/attributes/FillAttributesInterface";

var FillAttributes = createModule("gtl::FillAttributes", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::AttributesModel"], EventDispatcher, [
    ,
    {
        fillColor: 10,
        fillGradientNeutralColor: 10,
        fillGradientStartColor: 10,
        fillType: 4,
        transparency: 5,
        fillFile: 7,
        fillImageFitStyle: 4,
        fillGradientTransparency: 5,
        fillGradientEndColor: 10,
    },
    ,
    ,
    {
        copyFromBundle: [0,1],
        asFillAttributesInterface: [1],
        setStyle: [0,1],
        setStyleElement: [0,4],
        copyFrom: [0,1],
        setStyleElementChain: [0,[4]],
    },
    {
        _create: [4],
    },
    ,
]);
export default FillAttributes;
